module.exports = __webpack_public_path__ + "static/media/landing_hero3.00de8b0d.webp";